import { runWhenIdle } from './browserSurface';

const ENGAGEMENT_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'] as const;
const FALLBACK_AFTER_LOAD_MS = 4000;

export const afterEngagement = (run: () => void): (() => void) => {
  let done = false;
  let cancelIdle: (() => void) | null = null;
  let fallbackTimer: number | undefined;

  const detach = () => {
    ENGAGEMENT_EVENTS.forEach((name) => window.removeEventListener(name, fire));
    window.removeEventListener('load', armFallback);
    window.clearTimeout(fallbackTimer);
  };

  function fire() {
    if (done) return;
    done = true;
    detach();
    cancelIdle = runWhenIdle(run, { timeoutMs: 2000 });
  }

  function armFallback() {
    fallbackTimer = window.setTimeout(fire, FALLBACK_AFTER_LOAD_MS);
  }

  ENGAGEMENT_EVENTS.forEach((name) => window.addEventListener(name, fire, { passive: true }));
  if (document.readyState === 'complete') armFallback();
  else window.addEventListener('load', armFallback, { once: true });

  return () => {
    if (!done) detach();
    cancelIdle?.();
  };
};
